<section class="portfolio-skeleton">
  <!-- header section -->
  <div class="portfolio-skeleton__header-container">
    <div class="portfolio-skeleton__header container">
      <div class="portfolio-skeleton__header-left">
        <ngx-skeleton-loader
          count="1"
          class="flex gap-20"
          [theme]="{
            height: '3.5em',
            width: '3.5em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="2"
          class="flex flex-col gap-20"
          [theme]="{
            height: '1em',
            width: '5em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
      </div>

      <ngx-skeleton-loader
        count="4"
        class="flex gap-40"
        [theme]="{
          height: '4em',
          width: '4em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>

      <ngx-skeleton-loader
        count="2"
        class="flex gap-20"
        [theme]="{
          height: '2.5em',
          width: '4.5em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="portfolio-skeleton__container">
    <!-- hero section -->
    <div class="portfolio-skeleton__hero container">
      <ngx-skeleton-loader
        count="1"
        class="flex gap-20"
        [theme]="{
          height: '30em',
          width: '60.5em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        class="flex gap-20"
        [theme]="{
          height: '29.875em',
          width: '19.5em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
    </div>

    <!-- about section -->
    <div class="portfolio-skeleton__about container">
      <div class="portfolio-skeleton__about-left">
        <ngx-skeleton-loader
          count="1"
          class="flex gap-20"
          [theme]="{
            height: '2em',
            width: '10em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="4"
          class="flex flex-col gap-20"
          [theme]="{
            height: '1em',
            width: '30em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="3"
          class="flex gap-20"
          [theme]="{
            height: '3.125em',
            width: '9em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
      </div>
      <div class="portfolio-skeleton__about-right">
        <ngx-skeleton-loader
          count="1"
          class="flex gap-20"
          [theme]="{
            height: '19em',
            width: '33.5em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="3"
          class="flex flex-col gap-24"
          [theme]="{
            height: '5.375em',
            width: '5.375em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
      </div>
    </div>

    <!-- banner section -->
    <div class="portfolio-skeleton__banner container">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '3em',
          width: '60%',
          'margin-top': '0',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '30em',
          'margin-top': '2.5em',
        }"></ngx-skeleton-loader>
    </div>

    <!-- products section -->
    <div class="portfolio-skeleton__products container">
      <ngx-skeleton-loader
        count="2"
        class="flex justify-between gap-10"
        [theme]="{
          height: '2em',
          width: '10em',
          'margin-bottom': '2.375em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="4"
        class="flex justify-between gap-10"
        [theme]="{
          height: '28em',
          width: '20em',
          'margin-bottom': '0',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
    </div>

    <!-- team section -->
    <div class="portfolio-skeleton__team container">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '2em',
          width: '15em',
          'margin-bottom': '2.375em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
      <div class="portfolio-skeleton__team-top">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '11.5em',
            width: '12.5em',
            'margin-bottom': '-1em',
            'border-radius': '1em',
          }"></ngx-skeleton-loader>
        <div class="portfolio-skeleton__team-top-between">
          <div class="portfolio-skeleton__team-top-flex">
            <ngx-skeleton-loader
              count="3"
              class="flex flex-col gap-16"
              [theme]="{
                height: '1em',
                width: '12.5em',
                'margin-bottom': '0',
                'border-radius': '0.5em',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '3em',
                width: '9.75em',
                'margin-bottom': '0',
                'border-radius': '0.5em',
              }"></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="2"
            class="flex flex-col gap-16"
            [theme]="{
              height: '1em',
              width: '100%',
              'margin-bottom': '0',
              'border-radius': '0.5em',
            }"></ngx-skeleton-loader>
        </div>
      </div>
      <ngx-skeleton-loader
        count="4"
        class="flex justify-between gap-24"
        [theme]="{
          height: '20.875em',
          width: '20em',
          'margin-bottom': '5.125em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="3"
        class="flex gap-304"
        [theme]="{
          height: '1.5em',
          width: '10em',
          'margin-bottom': '2.5em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="3"
        class="flex justify-between gap-24"
        [theme]="{
          height: '35.75em',
          width: '46.75em',
          'margin-bottom': '4.625em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
    </div>
  </div>
  <!-- explore section -->
  <div class="portfolio-skeleton__explore">
    <div class="container">
      <ngx-skeleton-loader
        count="2"
        class="flex justify-between gap-10"
        [theme]="{
          height: '2em',
          width: '10em',
          'margin-bottom': '2.375em',
          'border-radius': '0.5em',
        }"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader
      count="4"
      class="flex justify-between gap-10"
      [theme]="{
        height: '33.125em',
        width: '27.375em',
        'margin-bottom': '2.875em',
        'border-radius': '0.5em',
      }"></ngx-skeleton-loader>
  </div>

  <!-- footer section -->
  <ngx-skeleton-loader
    count="1"
    class="mt-60"
    [theme]="{
      height: '20em',
      'margin-bottom': '0',
      'padding-bottom': '0',
    }"></ngx-skeleton-loader>
</section>
